import { create } from 'zustand';

export const useNotificationConnection = create<{ connected: boolean; everConnected: boolean; setConnected: (connected: boolean) => void }>((set) => ({
  connected: false,
  everConnected: false,
  setConnected: (connected) => set((current) => ({ connected, everConnected: current.everConnected || connected })),
}));
